import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import store from './store';
import Mixin from './mixin.js';

import VueCookies from 'vue3-cookies';
import VueDayjs from 'vue3-dayjs-plugin';
import VueCountdown from '@chenfengyuan/vue-countdown';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
library.add(fas, far, fab);

import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/bootstrap4-light-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import BadgeDirective from 'primevue/badgedirective';
import Tooltip from 'primevue/tooltip';

import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import ToastService from 'primevue/toastservice';

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import InputNumber from 'primevue/inputnumber';
import Password from 'primevue/password';
import Checkbox from 'primevue/checkbox';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import InputMask from 'primevue/inputmask';
import DynamicDialog from 'primevue/dynamicdialog';
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import ProgressSpinner from 'primevue/progressspinner';
import Tag from 'primevue/tag';
import InlineMessage from 'primevue/inlinemessage';
import Divider from 'primevue/divider';
import FileUpload from 'primevue/fileupload';
import ContextMenu from 'primevue/contextmenu';

import AppSpinner from './components/AppSpinner.vue';
import AppThreeDots from './components/AppThreeDots.vue';

createApp(App)
  .use(router)
  .use(store)
  .mixin(Mixin)
  
  .use(VueCookies)
  .use(VueDayjs)
  .component(VueCountdown.name, VueCountdown)

  .component('font-awesome-icon', FontAwesomeIcon)
  .use(PrimeVue, { ripple: true }) // Ripple is an optional animation for the supported components such as buttons.

  .directive('badge', BadgeDirective)
  .directive('tooltip', Tooltip)
  
  .use(ConfirmationService)
  .use(DialogService)
  .use(ToastService)

  .component('Button', Button)
  .component('InputText', InputText)
  .component('Textarea', Textarea)
  .component('InputNumber', InputNumber)
  .component('Password', Password)
  .component('Checkbox', Checkbox)
  .component('Dropdown', Dropdown)
  .component('Calendar', Calendar)
  .component('InputMask', InputMask)
  .component('DynamicDialog', DynamicDialog)
  .component('ConfirmDialog', ConfirmDialog)
  .component('Toast', Toast)
  .component('ProgressSpinner', ProgressSpinner)
  .component('Tag', Tag)
  .component('InlineMessage', InlineMessage)
  .component('Divider', Divider)
  .component('FileUpload', FileUpload)
  .component('ContextMenu', ContextMenu)

  .component('AppSpinner', AppSpinner)
  .component('AppThreeDots', AppThreeDots)

  .mount('#app');
